import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import KeywordDefinitionUI from './keyworddefinitionui';

export default class KeywordDefinition extends Plugin {
  static get pluginName() {
    return 'KeywordDefinition';
  }

  static get requires() {
    return [ KeywordDefinitionUI ];
  }
}
